import { trigger, state, style, transition, animate } from '@angular/animations';

/**
 * Height-based expand/collapse for a submenu's <ul>. Uses state() + height:'*'
 * (not :enter/:leave) because the <ul> must stay permanently in the DOM for
 * routerLinkActive to keep detecting the active parent while the sidebar is
 * collapsed/re-expanded — an @if here would destroy and recreate the node.
 */
export const expandCollapse = trigger('expandCollapse', [
  state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
  state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
  transition('closed <=> open', animate('220ms ease-in-out'))
]);
